import { render } from "./confirm-modal.vue?vue&type=template&id=772bdd22&scoped=true"
import script from "./confirm-modal.vue?vue&type=script&lang=js"
export * from "./confirm-modal.vue?vue&type=script&lang=js"

import "./confirm-modal.vue?vue&type=style&index=0&id=772bdd22&scoped=true&lang=css"

import exportComponent from "/Users/kariyaryoma/python/sg-post/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-772bdd22"]])

export default __exports__